import { IOrderProduct } from '../types/orderProduct';
import { IProductUnit } from '../types';
import { ShopMode } from '../redux/types';

/**
 * Get the effective price for a product based on shop mode
 * In LocalDelivery mode, use discountedPrice if available, otherwise use price
 * In DirectSale mode, always use price
 */
export const getEffectivePrice = (item: IOrderProduct, shopMode?: ShopMode): number => {
  if (shopMode === ShopMode.LocalDelivery && item.discountedPrice) {
    return item.discountedPrice;
  }
  return item.price;
};

export const calcProductTotal = (item: IOrderProduct, shopMode?: ShopMode): number => {
  const effectivePrice = getEffectivePrice(item, shopMode);

  if (item.unit === item.quantityUnit) {
    return effectivePrice * item.quantity;
  } else {
    if (item.unit === IProductUnit.kg && !!item.unitWeight) {
      return effectivePrice * item.unitWeight * item.quantity;
    } else {
      console.warn(`Item unit is ${item.unit} but unitWeight is ${item.unitWeight}`);
      return 0;
    }
  }
};

export const calcOrderProductsSubtotal = (
  orderProducts: IOrderProduct[],
  partner?: boolean,
  config?: { shippingCost: number; freeShippingThreshold: number; stripeShippingCost: number },
  shopMode?: ShopMode
): { subTotal: number; shippingCosts: number } => {
  let subTotal = 0;

  for (const prod of orderProducts) {
    subTotal += calcProductTotal(prod, shopMode);
  }

  if (shopMode === ShopMode.DirectSale) {
    const stripeShippingCost = config?.stripeShippingCost ?? 5.0;
    return { subTotal, shippingCosts: stripeShippingCost };
  } else {
    const shippingCost = config?.shippingCost ?? 1.5;
    const freeShippingThreshold = config?.freeShippingThreshold ?? 40;

    const shippingCosts = subTotal < freeShippingThreshold && !partner ? shippingCost : 0;

    return { subTotal, shippingCosts };
  }
};

export function alphabeticalSorting(a: string, b: string) {
  if (a < b) {
    return -1;
  } else if (a > b) {
    return 1;
  } else {
    return 0;
  }
}
